import $ from 'jquery'

function footer () {
  $('#footer-menu').each(function(){
    let dropdown = $(this).find('.menu-item-dropdown');
    dropdown.each(function(){
      let button = $(this).find('>a');
      let submenu = $(this).find('>.sub-menu');
      button.on('click' , function(e){
        e.preventDefault();
        submenu.slideToggle();
      });
    });
  });
}

export { footer }
